import { useSyncExternalStore } from 'react';

/**
 * 토스트(CR-027): 저장·생성·삭제 같은 서버 처리 결과를 화면 오른쪽 위에 짧게 알린다.
 * 뮤테이션은 queryClient 의 MutationCache 가 자동으로 성공/실패 토스트를 띄우므로 페이지에서 직접 부를 일은 드물다.
 *   toast.success('저장했습니다'); toast.error('실패 사유'); toast.info('…');
 * ToastHost 는 main.tsx 에 한 번만 둔다.
 */
type Kind = 'success' | 'error' | 'info';
interface Item { id: number; kind: Kind; message: string }
let items: Item[] = []; let seq = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
export function dismissToast(id: number) { if (!items.some((i) => i.id === id)) return; items = items.filter((i) => i.id !== id); emit(); }
function push(kind: Kind, message: string, ttl: number) {
  // 같은 메시지가 이미 떠 있으면 다시 띄우지 않는다 (연속 클릭·재시도 중복 방지)
  const dup = items.find((i) => i.kind === kind && i.message === message); if (dup) return dup.id;
  const id = ++seq; items = [...items.slice(-4), { id, kind, message }]; emit();
  window.setTimeout(() => dismissToast(id), ttl); return id;
}
export const toast = {
  success: (message: string, ttl = 2500) => push('success', message, ttl),
  error: (message: string, ttl = 7000) => push('error', message, ttl),
  info: (message: string, ttl = 3000) => push('info', message, ttl),
};
const CLS: Record<Kind, string> = { success: 'bg-green-50 border-green-300 text-green-900', error: 'bg-red-50 border-red-300 text-red-800', info: 'bg-sky-50 border-sky-300 text-sky-900' };
const ICON: Record<Kind, string> = { success: '✓', error: '!', info: 'i' };
export function ToastHost() {
  const list = useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => items, () => items);
  if (!list.length) return null;
  return (
    <div className="fixed right-3 top-12 z-[70] flex flex-col items-end gap-1 pointer-events-none">
      {list.map((t) => (
        <div key={t.id} role={t.kind === 'error' ? 'alert' : 'status'} className={`toast-in pointer-events-auto flex items-start gap-2 min-w-[16rem] max-w-[30rem] border px-3 py-1.5 text-[12.5px] shadow-md ${CLS[t.kind]}`}>
          <span className="font-bold w-3 text-center">{ICON[t.kind]}</span>
          <span className="flex-1 whitespace-pre-line leading-snug">{t.message}</span>
          <button type="button" className="opacity-60 hover:opacity-100 hover:underline" onClick={() => dismissToast(t.id)}>닫기</button>
        </div>
      ))}
    </div>
  );
}
